import { rootDomain } from '@lib/utils'
import { captureClientError } from '@lib/capture-client-error'
import isUrl from 'is-url'

/**
 * Validates a redirect URL and returns the safe redirect URL or null if invalid
 * @param redirectParameter The redirect URL to validate
 * @param currentHostname The current hostname for domain validation
 * @returns The validated redirect URL, or null if invalid (with error logged)
 */
export const validateRedirectUrl = (
  redirectParameter: string,
  currentHostname: string
): string | null => {
  // Handle relative URLs (inherently safe as they're same-domain)
  if (redirectParameter.startsWith('/')) {
    return redirectParameter
  }

  // Handle absolute URLs with domain validation
  if (isUrl(redirectParameter)) {
    try {
      const currentRootDomain = rootDomain(currentHostname)
      const redirectHostname = new URL(redirectParameter).hostname
      const redirectRootDomain = rootDomain(redirectHostname)

      if (currentRootDomain === redirectRootDomain) {
        return redirectParameter
      } else {
        captureClientError(
          new Error(
            `Invalid redirect URL: ${redirectParameter}. It should be in the same root domain.`
          )
        )
        return null
      }
    } catch (error) {
      captureClientError(
        new Error(`Error parsing redirect URL: ${redirectParameter}`, {
          cause: error,
        })
      )
      return null
    }
  } else {
    captureClientError(new Error(`Invalid redirect URL: ${redirectParameter}`))
    return null
  }
}
